import constants from 'constants/index'

const storageTime = ({ storageMode, value, volumetry }) => {
  const { STORY_MODE_DEFINED_TYPE, STORY_MODE_UNDEFINED_TYPE } =
    constants.dataProcess

  if (storageMode === STORY_MODE_DEFINED_TYPE) return `${value} ${volumetry}`

  if (storageMode === STORY_MODE_UNDEFINED_TYPE) return 'Indefinido'

  return 'Permanente'
}

export default storageTime
